import { useQuery } from "react-query";

import api from "../api";
import { QUERY_KEYS } from "../constants";

const client = api();

export default function useAdProducts() {
  const queryInfo = useQuery(QUERY_KEYS.AD_PRODUCTS, () =>
    client.getAdProducts(),
  );

  return { ...queryInfo, adProducts: queryInfo.data ?? [] };
}
